import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, ShieldCheckIcon, LayersIcon, EyeIcon } from 'lucide-react';
import { Container } from './ui/Container';
const outcomes = [{
  icon: ZapIcon,
  title: 'Faster Turnaround',
  desc: 'Cut down on email threads and manual hand-offs with automated routing.'
}, {
  icon: ShieldCheckIcon,
  title: 'Audit-Ready By Default',
  desc: 'Every request, action, and approval is logged for full accountability.'
}, {
  icon: LayersIcon,
  title: 'One Unified System',
  desc: 'Retire scattered spreadsheets, folders, and SharePoint sites.'
}, {
  icon: EyeIcon,
  title: 'Full Visibility',
  desc: 'Leadership gains a real-time view into the status of every request.'
}];
export function ImpactMetrics() {
  return <section className="py-20 bg-iris-surface border-y border-iris-border" data-id="element-141">
      <Container data-id="element-142">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-iris-border" data-id="element-143">
          {outcomes.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-iris-surface p-8 flex flex-col" data-id="element-144">
              <item.icon className="w-7 h-7 text-iris-green mb-5" data-id="element-145" />
              <h3 className="text-lg font-display font-bold text-white uppercase tracking-wide mb-2" data-id="element-146">
                {item.title}
              </h3>
              <p className="text-sm text-iris-muted leading-relaxed" data-id="element-147">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </Container>
    </section>;
}